import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { lastValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ConfigService {
  private http = inject(HttpClient);
  private _cachedFullUrl: string | null = null;

  /**
   * Fetches the SAS token from the API only if it's not already cached.
   */
  async getStorageConnection(): Promise<string> {
    if (this._cachedFullUrl) {
      return this._cachedFullUrl;
    }

    try {
      const url = `${environment.API_URL}commonservice?type=generateSasToken`;
      // Assuming API returns { token: "sv=2022..." }
      const res = await lastValueFrom(this.http.get<{ sasToken: string }>(url));

      this._cachedFullUrl = `${environment.ASSET_URL}?${res.sasToken}`;
      return this._cachedFullUrl;
    } catch (err) {
      console.error('Failed to fetch dynamic SAS token', err);
      throw err;
    }
  }

  // Clear cache if you suspect the token has expired mid-session
  clearCache() {
    this._cachedFullUrl = null;
  }
}
